import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classnames from 'classnames';
import React from 'react';
import KEY_CODES from '../../constants/key-codes';
import styles from './content-slider.scss';
export default class ContentSlider extends React.Component {
  constructor() {
    super(...arguments);
    // When navigation by tab, content can be scrolled by browser to show not visible focused elements
    // Used to move scroll back to initial state on blur not fully displayed last item at Lightbox
    _defineProperty(this, "preventScrollOnTab", event => {
      if (event.keyCode !== KEY_CODES.TAB || !this.containerRef.current) {
        return;
      }
      this.containerRef.current.scrollLeft = 0;
    });
    _defineProperty(this, "containerRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "contentRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "handleTransitionEnd", event => {
      if (event.target === this.contentRef.current) {
        if (this.props.onTransitionEnd !== undefined) {
          this.props.onTransitionEnd();
        }
      }
    });
  }
  componentDidMount() {
    document.addEventListener('keydown', this.preventScrollOnTab);
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.preventScrollOnTab);
  }
  getCurrentPageOffset() {
    const {
      currentPageNumber,
      width,
      isRTL
    } = this.props;
    const translateX = currentPageNumber * width * (isRTL ? 1 : -1);
    return {
      transform: "translate3d(" + translateX + "px, 0, 0)"
    };
  }
  render() {
    const {
      children,
      disabled,
      className,
      dataHook,
      isRTL
    } = this.props;
    const contentStyles = classnames(styles.content, {
      [styles.disabled]: disabled,
      [styles.rtl]: isRTL,
      [styles.ltr]: !isRTL
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-hook": dataHook,
      className: classnames(styles.container, className),
      ref: this.containerRef
    }, /*#__PURE__*/React.createElement("div", {
      className: contentStyles,
      ref: this.contentRef,
      onTransitionEnd: this.handleTransitionEnd,
      "data-hook": "content-slider-content",
      style: this.getCurrentPageOffset()
    }, children));
  }
}
//# sourceMappingURL=content-slider.js.map